import React from "react";
import {useTranslation} from "react-i18next";
import {
    StyledModal,
    StyledForm,
    StyledInput,
    KdvInfoContainer,
    KdvRow,
    DividerLine
} from "./UploadCreditModal.styles";

const UploadCreditModal = ({
    isCreditModalActive,
    setIsCreditModalActive,
    newCreditAmount,
    displayValue,
    handleInputChange,
    createPaymentLink,
    isPaymentLinkLoading,
    getKDVPercentage,
    calculateKDV,
    calculateKDVAddedAmount
}) => {
    const {t} = useTranslation();
    return (
        <StyledModal
            visible={isCreditModalActive}
            onCancel={() => setIsCreditModalActive(false)}
            centered
            title={"Kredi Yükle"}
            okText={"Tamam"}
            onOk={createPaymentLink}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            okButtonProps={{loading: isPaymentLinkLoading, disabled: !newCreditAmount}}
            width={480}
        >
            <StyledForm labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <StyledForm.Item label={"Yüklemek istediğiniz bakiye tutarını giriniz (₺)"}>
                    <StyledInput
                        placeholder={"Örn: 1.000,50"}
                        value={displayValue}
                        onChange={handleInputChange}
                        addonAfter="₺"
                        maxLength={15}
                    />

                    <KdvInfoContainer>
                        <KdvRow>
                            <span className="label">KDV (%{getKDVPercentage()})</span>
                            <span className="value">
                                {calculateKDV(newCreditAmount).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}{" "}
                                ₺
                            </span>
                        </KdvRow>

                        <DividerLine />

                        <KdvRow isLast isBold>
                            <span className="label">KDV Dahil Tutar</span>
                            <span className="value">
                                {calculateKDVAddedAmount(newCreditAmount).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}{" "}
                                ₺
                            </span>
                        </KdvRow>
                    </KdvInfoContainer>
                </StyledForm.Item>
            </StyledForm>
        </StyledModal>
    );
};

export default UploadCreditModal;
